import type { StateType } from '../../lib/types/state-type';
import type { RouteType } from '../../lib/types/route-type';
import { MODULES_WITH_SUB_ROUTES } from '../../lib/module-route';
import { setContent } from './set-content-reducer';

// Eine Route aus der URL. Sie laeuft durch dieselbe Rechtepruefung wie die Rail: setContent lenkt ein
// Modul ohne Recht auf home um.
export function applyRoute(state: StateType, parameters: unknown[]): StateType {
  const route = parameters[0] as RouteType;
  const contentState = setContent(state, [route.module]);

  // Die Sub-Route zaehlt nur, wenn das Modul wirklich geoeffnet wurde und eine versteht.
  if (contentState.content !== route.module || !MODULES_WITH_SUB_ROUTES.includes(route.module)) {
    return contentState;
  }

  return { ...contentState, moduleRoutes: { ...contentState.moduleRoutes, [route.module]: route.subRoute } };
}
